import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EventsList from '../pages/admin/events/EventsList';
import CreateEvent from '../pages/admin/events/CreateEvent';
import EditEvent from '../pages/admin/events/EditEvent';
import EventTickets from '../pages/admin/events/EventTickets';
import EventAttendees from '../pages/admin/events/EventAttendees';
import TicketVerification from '../pages/admin/events/TicketVerification';
import EventsPage from '../pages/public/events/EventsPage';
import EventDetailPage from '../pages/public/events/EventDetailPage';
import MyTickets from '../pages/public/tickets/MyTickets';
import TicketDetails from '../pages/public/tickets/TicketDetails';
import EventControl from '../pages/public/events/EventControl';

const EventsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EventsPage />} />
      <Route path=":id" element={<EventDetailPage />} />
      <Route path="my-tickets" element={<MyTickets />} />
      <Route path="../tickets/:ticketCode" element={<TicketDetails />} />
      <Route path="control/:slug" element={<EventControl />} />
      <Route path="admin" element={<EventsList />} />
      <Route path="admin/create" element={<CreateEvent />} />
      <Route path="admin/:id/edit" element={<EditEvent />} />
      <Route path="admin/:id/tickets" element={<EventTickets />} />
      <Route path="admin/:id/attendees" element={<EventAttendees />} />
      <Route path="admin/verify" element={<TicketVerification />} />
    </Routes>
  );
};

export default EventsRoutes;